import moment from 'moment';

const displayFormat = 'DD-MM-YYYY';
const legacyRevisionDateFormat = 'YYYYMMDD';
const apiDateOnlyFormat = 'YYYY-MM-DD';
const missingRevisionDateDisplay = '-';
const apiTimestampWithTimeZone = /T.*(?:Z|[+-]\d{2}:?\d{2})$/i;
const amsterdamDateFormatter = new Intl.DateTimeFormat('nl-NL', {
  timeZone: 'Europe/Amsterdam',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});

export function formatRevisionDateForDisplay(value: string | Date | null | undefined): string {
  if (!value) {
    return missingRevisionDateDisplay;
  }

  if (value instanceof Date) {
    return formatInstantForDisplay(value);
  }

  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return missingRevisionDateDisplay;
  }

  const legacyDate = moment(trimmedValue, legacyRevisionDateFormat, true);

  if (legacyDate.isValid()) {
    return legacyDate.format(displayFormat);
  }

  const apiDateOnly = moment(trimmedValue, apiDateOnlyFormat, true);

  if (apiDateOnly.isValid()) {
    return apiDateOnly.format(displayFormat);
  }

  if (!apiTimestampWithTimeZone.test(trimmedValue)) {
    return missingRevisionDateDisplay;
  }

  const apiTimestamp = moment.parseZone(trimmedValue, moment.ISO_8601, true);

  return apiTimestamp.isValid()
    ? formatInstantForDisplay(apiTimestamp.toDate())
    : missingRevisionDateDisplay;
}

export function formatRevisionDateForLegacyRoute(value: string): string {
  const legacyDate = moment(value, legacyRevisionDateFormat, true);

  if (legacyDate.isValid()) {
    return value;
  }

  return moment.parseZone(value).format(legacyRevisionDateFormat);
}

function formatInstantForDisplay(value: Date): string {
  if (Number.isNaN(value.getTime())) {
    return missingRevisionDateDisplay;
  }

  const parts = amsterdamDateFormatter.formatToParts(value);
  const day = parts.find(part => part.type === 'day')?.value;
  const month = parts.find(part => part.type === 'month')?.value;
  const year = parts.find(part => part.type === 'year')?.value;

  return day && month && year
    ? `${day}-${month}-${year}`
    : missingRevisionDateDisplay;
}
